export type GalleryTag =
  | "all"
  | "exterior"
  | "interior"
  | "sleeping"
  | "kitchen"
  | "camping"
  | "details";

export type GalleryImage = {
  id: string;
  src: string;
  jpegSrcSet: string;
  webpSrcSet: string;
  lightboxSrc: string;
  alt: string;
  caption?: string;
  tags: GalleryTag[];
  featured?: boolean;
};

const imageNames = [
  "IMG_0805.jpeg", "IMG_0806.jpeg", "IMG_0807.jpeg", "IMG_0808.jpeg", "IMG_0809.jpeg",
  "IMG_0810.jpeg", "IMG_0816.jpeg", "IMG_0820.jpeg", "IMG_0822.jpeg", "IMG_0824.jpeg",
  "IMG_0825.jpeg", "IMG_0829.jpeg", "IMG_0836.jpeg", "IMG_0840.jpeg", "IMG_0843.jpeg",
  "IMG_0846.jpeg", "IMG_0853.jpeg", "IMG_0855.jpeg", "IMG_0857.jpeg", "IMG_0858.jpeg",
  "IMG_0859.jpeg", "IMG_0860.jpeg", "IMG_0864.jpeg", "IMG_0868.jpeg", "IMG_0870.jpeg",
  "IMG_0877.jpeg", "IMG_0878.jpeg", "IMG_0880.jpeg", "IMG_0881.jpeg", "IMG_0884.jpeg",
  "IMG_0887.jpeg",
];

const tagGroups: GalleryTag[][] = [
  ["exterior"], ["exterior"], ["exterior"], ["exterior"], ["interior", "kitchen"],
  ["interior"], ["sleeping"], ["interior", "kitchen"], ["interior", "sleeping"], ["camping"],
  ["camping"], ["details"], ["interior"], ["interior", "kitchen"], ["sleeping"],
  ["details"], ["details"], ["camping"], ["interior"], ["interior", "kitchen"],
  ["details"], ["details"], ["camping"], ["interior"], ["exterior"], ["exterior"],
  ["sleeping"], ["camping"], ["details"], ["exterior"], ["exterior"],
];

export const galleryImages: GalleryImage[] = imageNames.map((name, index) => ({
  id: name.replace(".jpeg", ""),
  src: `/images/variants/${name.replace(".jpeg", "")}-800.jpeg`,
  jpegSrcSet: [480, 800, 1280, 1600].map((width) => `/images/variants/${name.replace(".jpeg", "")}-${width}.jpeg ${width}w`).join(", "),
  webpSrcSet: [480, 800, 1280, 1600].map((width) => `/images/variants/${name.replace(".jpeg", "")}-${width}.webp ${width}w`).join(", "),
  lightboxSrc: `/images/variants/${name.replace(".jpeg", "")}-1600.jpeg`,
  alt: `Camper van photograph ${index + 1}`,
  tags: ["all", ...(tagGroups[index] ?? ["details"])],
  featured: ["IMG_0805", "IMG_0806", "IMG_0887", "IMG_0868", "IMG_0820"].includes(name.replace(".jpeg", "")),
}));

export const vehicle = {
  title: "2016 Volkswagen Transporter Camper Van",
  email: import.meta.env.VITE_SALE_EMAIL || "transporter-for-sale@markforster.info",
  salePrice: Number(import.meta.env.VITE_SALE_PRICE || "31995"),
  engineMiles: Number(import.meta.env.VITE_ENGINE_MILES || "250"),
  registration: "WU66 CLZ",
  facts: [
    ["Year", "2016"],
    ["Fuel type", "Diesel"],
    ["Engine", "1,968cc"],
    ["Colour", "White"],
    ["MOT", "Expires 2 August 2027"],
    ["Tax", "Due 1 October 2026"],
  ],
};

export const formattedSalePrice = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  maximumFractionDigits: 0,
}).format(vehicle.salePrice);

export const formattedEngineMiles = new Intl.NumberFormat("en-GB").format(vehicle.engineMiles);

export const emailHref = `mailto:${vehicle.email}?subject=${encodeURIComponent(
  "Enquiry about the Volkswagen Transporter camper van",
)}&body=${encodeURIComponent(
  "Hello Mark,\n\nI’m interested in learning more about the Volkswagen Transporter camper van.\n\nPlease could you send me some more information?\n\nThanks,",
)}`;

export const filterLabels: { value: GalleryTag; label: string }[] = [
  { value: "all", label: "All" },
  { value: "exterior", label: "Exterior" },
  { value: "interior", label: "Interior" },
  { value: "sleeping", label: "Sleeping" },
  { value: "kitchen", label: "Kitchen and storage" },
  { value: "camping", label: "Camping equipment" },
  { value: "details", label: "Details" },
];
